import { Box, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { getOrchestrator } from "../../slices/orchestrator";

// Dedupe in-flight / completed lookups across many table cells
const requestedOrchestratorIds = new Set();

const NiceOrchestrator = (props) => {
  const dispatch = useDispatch();
  const value = props.children;

  // Check if value is an array (for multiple orchestrators)
  const isArray = Array.isArray(value);
  const orchestratorIds = isArray ? value : [value];

  // Get orchestrators from Redux store
  const orchestrators = useSelector((state) => {
    return orchestratorIds
      .map(id => state.orchestrators.data.list?.find((org) => org.id === id))
      .filter(Boolean); // Remove undefined values
  });

  useEffect(() => {
    // Fetch any orchestrators that aren't in the store yet
    orchestratorIds.forEach(id => {
      if (!id || id === "ALL" || id === "Not Set") {
        return;
      }
      const exists = orchestrators.find(o => o?.id === id);
      if (!exists && !requestedOrchestratorIds.has(id)) {
        requestedOrchestratorIds.add(id);
        dispatch(getOrchestrator({ id }));
      }
    });
  }, [orchestratorIds.join(',')]);

  // Handle empty or invalid values
  if (!value || (isArray && value.length === 0)) {
    return <Box sx={{ color: "text.secondary", fontStyle: "italic" }}>-</Box>;
  }

  // Render single orchestrator
  if (!isArray) {
    const orchestratorId = value;
    const orchestrator = orchestrators[0];

    return (
      <>
        {orchestratorId === "ALL" ? (
          <Box>ALL</Box>
        ) : (
          orchestrator && (
            <Box display="flex" justifyContent="start" alignItems="baseline">
              {orchestrator.name}
            </Box>
          )
        )}
      </>
    );
  }

  // Render array of orchestrators
  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      {orchestrators.map((orchestrator, index) => (
        orchestrator && (
          <Box
            key={orchestrator.id}
            display="flex"
            justifyContent="start"
            alignItems="baseline"
            sx={{
              '&:not(:last-child)::after': {
                content: '","',
                marginLeft: 0.5
              }
            }}
          >
            {orchestrator.name}
          </Box>
        )
      ))}
    </Stack>
  );
};

export default React.memo(NiceOrchestrator);
